/*-----------------------------------
ハンバーガーメニュー
-----------------------------------*/
const menuBtn = document.querySelector('.js-menu-toggle');
const spMenu = document.querySelector('.sp-menu');

menuBtn.addEventListener('click', () => {
  menuBtn.classList.toggle('open');
  spMenu.classList.toggle('open');
  document.body.classList.toggle('menu-open');
});

/*-----------------------------------
アンカーリンクのスムーススクロール
-----------------------------------*/
const anchorLinks = document.querySelectorAll('a[href^="#"]');

anchorLinks.forEach(link => {
  link.addEventListener('click', (e) => {
    e.preventDefault();
    
    const targetId = link.getAttribute('href');
    const targetElement = document.querySelector(targetId);
    
    if (targetElement) {
      // スマホメニューが開いている場合は閉じる
      if (spMenu.classList.contains('open')) {
        menuBtn.classList.remove('open');
        spMenu.classList.remove('open');
        document.body.classList.remove('menu-open');
      }
      
      // スマホ表示の場合、ヘッダー高さ分のオフセットを追加
      const isMobile = window.innerWidth <= 750;
      
      if (isMobile) {
        const header = document.querySelector('.sp-header');
        const headerHeight = header ? header.offsetHeight : 60; // ヘッダー高さを取得
        const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      } else {
        // PC表示の場合は通常のスクロール
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  });
});

/*-----------------------------------
スワイパー
-----------------------------------*/
const swiper = new Swiper('.swiper', {
  loop: true,
  loopedSlides: 3,
  loopAdditionalSlides: 1,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  speed: 800,
  grabCursor: true,
  centeredSlides: true,
  spaceBetween: 5,
  slidesPerView: 'auto',
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  on: {
    slideChange: function () {
      const lines = document.querySelectorAll('.slider-lines .line');
      lines.forEach(line => line.classList.remove('active'));
      
      let activeIndex = this.realIndex;
      if(lines[activeIndex]) lines[activeIndex].classList.add('active');
    }
  }
});

